import { ApplicationElement, html } from '../application_element/element.js';

/**
 * Element with icon title and body
 *
 * @prop none - render as slot with content: hero(title: "Agenda", icon: "calendar-day". short: "Lorem ipsum...")
 */
export default class Hero extends ApplicationElement {
  render() {
    return html` <slot></slot> `;
  }
}

customElements.get('ef-hero') || customElements.define('ef-hero', Hero);
